<template>
  <div id="faqs-page">
    <HeroSection />
    <FaqsSection />
  </div>
</template>

<script>
import HeroSection from "@/components/landing/faqs/HeroSection.vue";
import FaqsSection from "@/components/landing/faqs/FaqSection.vue";

export default {
  name: "Faqs",

  components: {
    HeroSection,
    FaqsSection,
  },
};
</script>

<style lang="scss" scoped></style>
